import Vue from 'vue'
import Router from 'vue-router'
import Churabou from '@/pages/Churabou'
import Profile from '@/pages/Profile'
import Skills from '@/pages/Skills'
import Appeal from '@/pages/Appeal'
import Outputs from '@/pages/Outputs'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Churabou',
      component: Churabou
    },

    {
      path: '/skills',
      name: 'skills',
      component: Skills
    },

    {
      path: '/appeal',
      name: 'Appeal',
      component: Appeal
    },

    {
      path: '/outputs',
      name: 'Outputs',
      component: Outputs
    },

    {
      path: '/profile',
      name: 'profile',
      component: Profile
    }
  ]
})


// HOGE.vueにあるコンポ年とを読んでくる。
// ファイル名とクラス名が違っていても問題ない。
// https://vue-loader-v14.vuejs.org/ja/start/spec.html
// teplete script styleタグが複数ある場合は一番下にあるものがそれぞれ読まれる



// WEBPACK FOOTER //
// ./src/router/index.js